export const iconFontAwesomeUsersPeoplePersonMilitaryRifle = (
	<i className="fa-solid fa-person-military-rifle"></i>
);
